import { render, staticRenderFns } from "./setPin.vue?vue&type=template&id=0f3d535e&scoped=true"
import script from "./setPin.vue?vue&type=script&lang=js"
export * from "./setPin.vue?vue&type=script&lang=js"
import style0 from "./setPin.vue?vue&type=style&index=0&id=0f3d535e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f3d535e",
  null
  
)

export default component.exports